import * as actionTypes from "../ActionTypes";

export const getBibleLanguagesAction = (payload) => {
  return {
    type: actionTypes.GET_BIBLE_LANGUAGES_REQUEST,
    payload: payload,
  };
};
export const getBibleSearchAction = (payload) => {
  return {
    type: actionTypes.GET_BIBLE_SEARCH,
    payload: payload,
  };
};
// Action creator for getJournalsAction
export const getJournalsAction = (payload) => {
  return {
    type: actionTypes.GET_JOURNALS,
    payload: payload,
  };
};
export const getBibleVersionsAction = (payload) => {
  return {
    type: actionTypes.GET_BIBLE_VERSIONS_REQUEST,
    payload: payload,
  };
};

export const setBibleLanguage = (payload) => {
  return {
    type: actionTypes.SET_BIBLE_LANGUAGE,
    payload: payload,
  };
};

export const setBibleLanguageName = (payload) => {
  return {
    type: actionTypes.SET_BIBLE_LANGUAGE_NAME,
    payload: payload,
  };
};

export const setBibleCountryLanguagesAction = (payload) => {
  return {
    type: actionTypes.SET_BIBLE_COUNTRY_LANGUAGES,
    payload: payload,
  };
};

export const setAllBibleLanguagesAction = (payload) => {
  return {
    type: actionTypes.SET_ALL_BIBLE_LANGUAGES,
    payload: payload,
  };
};

export const setAllJournalsAction = (payload) => {
  return {
    type: actionTypes.SET_ALL_JOURNALS,
    payload: payload,
  };
};

export const setBibleVersion = (payload) => {
  return {
    type: actionTypes.SET_BIBLE_VERSION,
    payload: payload,
  };
};

export const setVersionDetails = (payload) => {
  return {
    type: actionTypes.SET_VERSION_DETAILS,
    payload: payload,
  };
};

export const setVersionDetailsLoading = (payload) => {
  return {
    type: actionTypes.SET_VERSION_DETAILS_LOADING,
    payload: payload,
  };
};

export const setActiveSearchTabAction = (payload) => {
  return {
    type: actionTypes.SET_ACTIVE_SEARCH_TAB,
    payload: payload,
  };
};

export const getBibleCountryLanguagesAction = (payload) => {
  return {
    type: actionTypes.GET_BIBLE_COUNTRY_LANGUAGES_REQUEST,
    payload: payload,
  };
};

export const setBookChapterDetails = (payload) => {
  return {
    type: actionTypes.SET_BOOK_CHAPTER_DETAILS,
    payload: payload,
  };
};

export const setBookChapterDetailsLoading = (payload) => {
  return {
    type: actionTypes.SET_BOOK_CHAPTER_DETAILS_LOADING,
    payload: payload,
  };
};

export const getVersionBooks = (payload) => {
  return {
    type: actionTypes.GET_VERSION_BOOKS_REQUEST,
    payload: payload,
  };
};

export const getChapterDetails = (payload) => {
  return {
    type: actionTypes.GET_BIBLE_CHAPTER_DETAILS,
    payload: payload,
  };
};

export const getBibleSearch = (payload) => {
  return {
    type: actionTypes.GET_BIBLE_SEARCH,
    payload: payload,
  };
};

export const getChapterVideos = (payload) => {
  return {
    type: actionTypes.READ_CHAPTER_VIDEOS_REQUEST,
    payload: payload,
  };
};

export const saveChapterVideos = (payload) => {
  return {
    type: actionTypes.SAVE_CHAPTER_VIDEOS_REQUEST,
    payload: payload,
  };
};

export const deleteChapterVideos = (payload) => {
  return {
    type: actionTypes.DELETE_CHAPTER_VIDEOS_REQUEST,
    payload: payload,
  };
};

export const getChapterJournals = (payload) => {
  return {
    type: actionTypes.READ_CHAPTER_JOURNALS_REQUEST,
    payload: payload,
  };
};

export const saveChapterJournals = (payload) => {
  return {
    type: actionTypes.SAVE_CHAPTER_JOURNALS_REQUEST,
    payload: payload,
  };
};

export const deleteChapterJournals = (payload) => {
  return {
    type: actionTypes.DELETE_CHAPTER_JOURNALS_REQUEST,
    payload: payload,
  };
};

export const getVerseDetails = (payload) => {
  return {
    type: actionTypes.READ_VERSE_DETAILS_REQUEST,
    payload: payload,
  };
};

export const getSpeakersListAction = (payload) => {
  return {
    type: actionTypes.GET_SPEAKERS_LIST_REQUEST,
    payload: payload,
  };
};

export const saveSpeakerDetailsAction = (payload) => {
  return {
    type: actionTypes.SAVE_SPEAKER_DETAILS_REQUEST,
    payload: payload,
  };
};

export const updateSpeakerDetailsAction = (payload) => {
  return {
    type: actionTypes.UPDATE_SPEAKER_DETAILS_REQUEST,
    payload: payload,
  };
};

export const deleteSpeakerAction = (payload) => {
  return {
    type: actionTypes.DELETE_SPEAKER_DETAILS_REQUEST,
    payload: payload,
  };
};

export const getJournalCategoriesAction = (payload) => {
  return {
    type: actionTypes.GET_JOURNAL_CATEGORIES_REQUEST,
    payload: payload,
  };
};

export const saveJournalCategoriesAction = (payload) => {
  return {
    type: actionTypes.SAVE_JOURNAL_CATEGORIES_REQUEST,
    payload: payload,
  };
};

export const updateJournalCategoriesAction = (payload) => {
  return {
    type: actionTypes.UPDATE_JOURNAL_CATEGORIES_REQUEST,
    payload: payload,
  };
};

export const deleteJournalCategoriesAction = (payload) => {
  return {
    type: actionTypes.DELETE_JOURNAL_CATEGORIES_REQUEST,
    payload: payload,
  };
};

// Journal Speaker Actions
export const saveJournalLanguageSpeakerAction = (payload) => ({
  type: actionTypes.SAVE_JOURNAL_LANGUAGE_SPEAKER_REQUEST,
  payload,
});
export const updateJournalLanguageSpeakerAction = (payload) => ({
  type: actionTypes.UPDATE_JOURNAL_LANGUAGE_SPEAKER_REQUEST,
  payload,
});
export const deleteJournalLanguageSpeakerAction = (payload) => ({
  type: actionTypes.DELETE_JOURNAL_LANGUAGE_SPEAKER_REQUEST,
  payload,
});

// Journal Category Actions
export const saveJournalLanguageCategoryAction = (payload) => ({
  type: actionTypes.SAVE_JOURNAL_LANGUAGE_CATEGORY_REQUEST,
  payload,
});
export const updateJournalLanguageCategoryAction = (payload) => ({
  type: actionTypes.UPDATE_JOURNAL_LANGUAGE_CATEGORY_REQUEST,
  payload,
});
export const deleteJournalLanguageCategoryAction = (payload) => ({
  type: actionTypes.DELETE_JOURNAL_LANGUAGE_CATEGORY_REQUEST,
  payload,
});

// Journal Language Actions
export const saveJournalLanguageAction = (payload) => ({
  type: actionTypes.SAVE_JOURNAL_LANGUAGE_REQUEST,
  payload,
});
export const updateJournalLanguageAction = (payload) => ({
  type: actionTypes.UPDATE_JOURNAL_LANGUAGE_REQUEST,
  payload,
});
export const deleteJournalLanguageAction = (payload) => ({
  type: actionTypes.DELETE_JOURNAL_LANGUAGE_REQUEST,
  payload,
});

// Journal Notes Language Actions
export const saveJournalLanguageNotesAction = (payload) => ({
  type: actionTypes.SAVE_JOURNAL_LANGUAGE_NOTES_REQUEST,
  payload,
});
export const updateJournalLanguageNotesAction = (payload) => ({
  type: actionTypes.UPDATE_JOURNAL_LANGUAGE_NOTES_REQUEST,
  payload,
});
export const deleteJournalLanguageNotesAction = (payload) => ({
  type: actionTypes.DELETE_JOURNAL_LANGUAGE_NOTES_REQUEST,
  payload,
});

// Journal NoteItems Language Actions
export const saveJournalLanguageNoteItemsAction = (payload) => ({
  type: actionTypes.SAVE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST,
  payload,
});
export const updateJournalLanguageNoteItemsAction = (payload) => ({
  type: actionTypes.UPDATE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST,
  payload,
});
export const deleteJournalLanguageNoteItemsAction = (payload) => ({
  type: actionTypes.DELETE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST,
  payload,
});
